/**
 * UnavailableReason - persistent, always-visible "why unavailable" text
 * (Story #5351 W1-T4, FAIL-05 rendering rule: a reason must be readable
 * without hovering — a tooltip-only explanation is invisible to touch,
 * keyboard, and screen-reader users).
 */
import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface UnavailableReasonProps {
  reason: string;
  className?: string;
}

const UnavailableReason: React.FC<UnavailableReasonProps> = ({ reason, className }) => (
  <p
    role="note"
    className={`flex items-start gap-1.5 text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-2.5 py-1.5 ${className ?? ''}`}
  >
    <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" aria-hidden="true" />
    <span>{reason}</span>
  </p>
);

export default UnavailableReason;
